import type { SessionBase } from '@asi/auth/types-auth';

import type { CollectionAccessTokenRequest } from '../types/collection-access-token-request';

/**
 * `@__PURE__` IIFE — tree-shakable by esbuild/Rollup/Webpack when unused.
 *
 * Keep `ACTION_SCOPE` defined INSIDE the IIFE — external variable references
 * in static initializers break tree-shaking even with `@__PURE__`.
 *
 * Avoid namespace — compiles to a var + IIFE pattern that bundlers treat
 * as a side effect, preventing tree-shaking regardless of `@__PURE__`.
 */
export const CustomerPortalCollectionAuthActions = /*@__PURE__*/ (() => {
  const ACTION_SCOPE = '[Customer-Portal Collection Auth]';

  const CustomerPortalCollectionAuthActions = {
    LoginWithAccessCode: class {
      static type = `${ACTION_SCOPE} Login With Access Code`;

      constructor(public payload: CollectionAccessTokenRequest) {}
    },

    LoginSuccess: class {
      static type = `${ACTION_SCOPE} LoginSuccess`;

      constructor(public session: SessionBase) {}
    },

    RestoreFromLocalStorage: class {
      static type = `${ACTION_SCOPE} Restore From Local Storage`;

      constructor(
        public session: SessionBase,
        public accessCode: string
      ) {}
    },
  };

  return CustomerPortalCollectionAuthActions;
})();

// Export the type separately so it can be used as a namespace for instance types.
export type CustomerPortalCollectionAuthActions =
  typeof CustomerPortalCollectionAuthActions;
